// @ts-strict-ignore
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

import cls from './HeroInfoTabs.module.scss'

export type HeroInfoTabsProps = {
	tabItems?: {
		title: string
		link: string
		isActive?: boolean
	}[]
}

export const HeroInfoTabs = ({ tabItems }: HeroInfoTabsProps): JSX.Element => (
	<section className={cls.heroInfoTabs}>
		{tabItems.map(item => (
			<Link
				prefetch={false}
				key={item.title}
				href={item.link}
				className={clsx(cls.heroInfoTabs__item, item.isActive && cls.heroInfoTabs__item_active)}
				title={item.title}>
				{item.title}
			</Link>
		))}
	</section>
)
